import { hooks as metaMaskHooks, metaMask } from './metamask'
export const connectors = [
    [metaMask, metaMaskHooks],
    // [walletConnect, walletConnectHooks],
    // [coinbaseWallet, coinbaseWalletHooks],
    // [network, networkHooks],
]
